// Vendors
import React from 'react'

// Components
import { FormCompanyAddress } from 'pages/private/Company/form/FormCompanyAddress'
import { FormCompanyInfo } from 'pages/private/Company/form/FormCompanyInfo'

// Styles
import { Box } from '@chakra-ui/react'

export const TabGeneral = () => {
  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */

  return (
    <Box>
      <FormCompanyInfo />
      <FormCompanyAddress />
    </Box>
  )
}
